import * as React from "react";
import cx from "classnames";

import { Color as ColorModel } from "../../../models";
import { Color } from "../../../components";

interface ColorFieldProps {
  chosenColor?: ColorModel;
  label: string;
  error?: React.ReactChild;
  onClick: () => void;
}

const getErrClasses = ({ error }: ColorFieldProps) =>
  cx("color-field__error", {
    "form-control__error": error,
  });

const ColorField = (props: ColorFieldProps) => (
  <div className="form-group color-field">
    <label className="control-label col-md-4">{props.label}</label>
    <div className="col-md-8 color-field__container">
      <div className="form-control">
        <div
          className="custom-color-item"
          style={{ padding: 0 }}
          onClick={props.onClick}
        >
          {props.chosenColor ? (
            <Color mini {...props.chosenColor} />
          ) : (
            <div
              className={cx("custom-color-item__preview", "empty", {
                "empty--error": props.error,
              })}
            >
              <i
                className={cx("fa", "fa-plus", "icon", {
                  "icon--error": props.error,
                })}
              />
            </div>
          )}
        </div>
        <div className={getErrClasses(props)}>{props.error}</div>
      </div>
    </div>
  </div>
);

export default ColorField;



// WEBPACK FOOTER //
// ./src/routes/WizardColorChoice/components/ColorField.tsx